import {useGetDiagnoses} from '@/features/projects/queries/useGetDiagnoses'
import {useInputSearch} from '@/hooks/useInputSearch'

interface UsePathologiesSearchableListProps {
    limit?: number
    enabled?: boolean
}

export const usePathologiesSearchableList = ({limit = 10, enabled}: UsePathologiesSearchableListProps) => {
    const searchControls = useInputSearch()
    const query = useGetDiagnoses({
        params: {
            page: 1,
            limit,
            search: searchControls.searchValue
        },
        options: {enabled}
    })

    return {
        ...query,
        ...searchControls,
        pathologies: query.data?.pages.flatMap(page => page.data) ?? []
    }
}
